import { render, staticRenderFns } from "./P3.vue?vue&type=template&id=2c8b2aac&scoped=true"
import script from "./P3.vue?vue&type=script&lang=js"
export * from "./P3.vue?vue&type=script&lang=js"
import style0 from "./P3.vue?vue&type=style&index=0&id=2c8b2aac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b2aac",
  null
  
)

export default component.exports